import { useEffect, useSyncExternalStore } from 'react';
import { useTranslation } from 'react-i18next';
import { type Toast, toast } from '../lib/toast.js';

// #93: 'info' bekommt eine eigene Anzeigedauer zwischen success (kurz, positiv) und error (lang,
// muss gelesen werden) — der Hinweis ist wichtig genug zum Lesen, aber kein Fehler.
const DISMISS_MS: Record<Toast['kind'], number> = { success: 4000, error: 8000, info: 6000 };

// #93: Tonfarbe je Kind — 'info' folgt dem Muster der zwei bestehenden Kinds (Border-Akzent +
// Textfarbe), bekommt aber zusätzlich `bg-[var(--tint-blue)]` als Grundton (Brief), weil ein
// neutraler Hinweis sonst optisch nicht von einer normalen Karte zu unterscheiden wäre.
const TONE_CLASS: Record<Toast['kind'], string> = {
  success: 'border-l-status-pass text-status-pass',
  error: 'border-l-status-fail text-status-fail',
  info: 'border-l-brand-accent text-text-body bg-[var(--tint-blue)]',
};

function ToastItem({ item }: { item: Toast }) {
  const { t } = useTranslation();
  useEffect(() => {
    const timer = setTimeout(() => toast.dismiss(item.id), DISMISS_MS[item.kind]);
    return () => clearTimeout(timer);
  }, [item.id, item.kind]);

  const tone = TONE_CLASS[item.kind];
  return (
    <div
      role={item.kind === 'error' ? 'alert' : 'status'}
      className={`flex items-start gap-3 rounded-card border border-[var(--border)] border-l-4 ${tone} bg-bg-surface px-3 py-2 shadow-sm`}
    >
      <span className="text-sm text-text-body">{item.message}</span>
      <button
        type="button"
        onClick={() => toast.dismiss(item.id)}
        aria-label={t('feedback.dismiss')}
        className="ml-auto text-text-muted hover:text-text-primary"
      >
        ✕
      </button>
    </div>
  );
}

export function ToastViewport() {
  const items = useSyncExternalStore(toast.subscribe, toast.getSnapshot);
  return (
    <div
      aria-live="polite"
      className="fixed bottom-4 right-4 z-50 flex w-80 max-w-[calc(100vw-2rem)] flex-col gap-2"
    >
      {items.map((item) => (
        <ToastItem key={item.id} item={item} />
      ))}
    </div>
  );
}
